// Handle drone targeting
const targetDrone = (
  targetZone,
  targetIndex,
  ws,
  setError,
  setDroneTargetMode,
  setSelectedDroneId,
  setSelectedDroneInstanceId,
  selectedDroneId,
  selectedDroneInstanceId,
  gameId,
  gameState,
  userId,
  targetInstanceIdOverride = null
) => {
  if (!ws || ws.readyState !== 1) {
    setError("Connection lost. Please refresh the page.");
    return;
  }

  let targetUnitId = userId;
  let targetInstanceId = targetInstanceIdOverride;

  if (targetZone === 'hand') {
    const handCard = gameState?.state?.[userId]?.hand?.[targetIndex];
    if (!targetInstanceId) {
      targetInstanceId = handCard?.instanceId;
    }
    if (!targetInstanceId) {
      setError('Select a unit card in your hand');
      return;
    }
  } else {
    if (targetZone === "opponent_front" || targetZone === "opponent_flank") {
      const opponentId = gameState?.players?.find(id => id !== userId);
      targetUnitId = opponentId;
    }

    const normalizedZone = targetZone.replace('opponent_', '');
    const targetPlayer = gameState?.state?.[targetUnitId];
    const targetUnit = targetPlayer?.playedOrders?.[normalizedZone]?.[targetIndex];
    targetInstanceId = targetInstanceId || targetUnit?.instanceId;
  }

  const action = {
    type: "play-turn",
    gameId: gameId,
    action: {
      type: "activateDrone",
      droneId: selectedDroneId,
      droneInstanceId: selectedDroneInstanceId,
      targetUnitId: targetUnitId,
      targetZone: targetZone,
      targetIndex: targetIndex,
      targetInstanceId: targetInstanceId
    }
  };

  ws.send(JSON.stringify(action));

  setDroneTargetMode(false);
  setSelectedDroneId(null);
  setSelectedDroneInstanceId(null);
};

export default targetDrone;
